import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import DemeritEducationAbout from '@di-shared/features/public-service/demerit-education/DemeritEducationAbout';

interface DemeritEducationAboutPageProps {
  vin: string;
}

function DemeritEducationAboutPage({vin}: DemeritEducationAboutPageProps) {
  return (
    <>
      <ScrollToTopOnMount />
      <DemeritEducationAbout vin={vin} />
    </>
  );
}

export default DemeritEducationAboutPage;
